import { render } from "./NotFound404.vue?vue&type=template&id=d5788b96"
import script from "./NotFound404.vue?vue&type=script&lang=js"
export * from "./NotFound404.vue?vue&type=script&lang=js"
script.render = render

export default script